import requests from "./httpService";
import dayjs from "dayjs";

const AttendanceServices = {
  getAllAttendance: async ({ employeeID, fromTime, toTime, type }) => {
    var startTime = "";
    var endTime = "";

    if (fromTime) {
      startTime = fromTime.replace("T", " ")
      startTime = dayjs(startTime).format("YYYY-MM-DD")
    }
    if (toTime) {
      var time = toTime + "23:59:59";
      endTime = time.replace("T", " ")
      endTime = dayjs(endTime).format("YYYY-MM-DD")
    }
    type = type === "" ? "all" : type;
    return requests.get(`/attenance/all?employee=${employeeID}&fromDate=${startTime}&toDate=${endTime}&type=${type}`);
  },
  getEmployeeAttendanceById: async ({ id }) => {
    if (id)
      return requests.get(`/attenance/${id}`);
  }
};

export default AttendanceServices; 
